import "./App.css";
import { BrowserRouter as Router, useRoutes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "./Subcomponents/Loader";
import Mainpage from "./Pages/Mainpage/Mainpage";
import Login from "./Components/Login/Login";
import Home from "./Components/Home/Home";
import Tokens from "./Components/Tokens/Tokens";
import { useDispatch, useSelector } from "react-redux";
import actions from "./Redux Store/actions";
import { useEffect, useRef, useState } from "react";
import Profile from "./Components/Profile/Profile";
import PreselectAllotments from "./Components/PreselectAllotments/PreselectAllotments";
import CancelUnits from "./Components/CancelUnits/CancelUnits";
import Services from "./Pages/Services/Services";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import CancellationPolicy from "./Pages/CancellationPolicy/CancellationPolicy";
import ContactUs from "./Pages/ContactUs/ContactUs";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Help from "./Pages/Help/Help";
import Transactions from "./Components/Transactions/Transactions";
import { supabase } from "./supabaseClient";
import LogoutPopup from "./Modals/TokenExpireModal/logoutPopup";
import OnlineBookingUnitSelection from "./Components/OnlineBookingUnitSelection/OnlineBookingUnitSelection";
import FloorMappingNew from "./Components/OnlineBooking/FloorMappingNew";
import BuildingSelection from "./Components/OnlineBooking/BuildingSelection";
import SingleUnitSelectionDetails from "./Components/OnlineBooking/SingleUnitSelectionDetails";
import TowerAUnitSelection from "./Components/PalladioLaVientoOnlineBookingUnitSelection/TowerA1UnitSelection";
import TowerA1UnitSelection from "./Components/PalladioLaVientoOnlineBookingUnitSelection/TowerA1UnitSelection";
import TowerA2UnitSelection from "./Components/PalladioLaVientoOnlineBookingUnitSelection/TowerA2UnitSelection";
import TowerB1UnitSelection from "./Components/PalladioLaVientoOnlineBookingUnitSelection/TowerB1UnitSelection";
import TowerB2UnitSelection from "./Components/PalladioLaVientoOnlineBookingUnitSelection/TowerB2UnitSelection";

// EMandate Components
import EMandateDashboard from "./Components/EMandateDashboard/EMandateDashboard";
import EMandateSplit from "./Components/EMandate/EMandateSplit";
import SplitOption from "./Components/EMandate/SplitOption";
import BankVerification from "./Components/EMandate/BankVerification";
import EMandateAllotmentRoute from "./Components/EMandateAllotmentRoute/EMandateAllotmentRoute";
import ConfirmPaymentSchedule from "./Components/EMandate/ConfirmPaymentSchedule";
import SingleApplicant from "./Components/EMandate/SingleApplicant";
import SplitAmount from "./Components/EMandate/SplitAmount";
import LoanAssist from "./Components/LoanAssist/LoanAssist";
import TutorialsPage from "./Components/LoanAssist/TutorialsPage";
import EMandateAllotmentHandlerPage from "./Components/EMandateAllotmentRoute/EMandateAllotmentHandlerPage";
import Documents from "./Pages/Documents/Documents";

// Hash a string to hex (browser WebCrypto)
async function sha256Hex(str) {
	const enc = new TextEncoder().encode(str);
	const buf = await crypto.subtle.digest("SHA-256", enc);
	return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, "0")).join("");
}

function App() {
	const dispatch = useDispatch();
	// const navigate = useNavigate();
	dispatch(actions.authCheck());
	const isAuthenticatedUseRef = useRef(false);
	const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
	const [isOnline, setIsOnline] = useState(true);
	const [showModal, setShowModal] = useState(false);
	const isSwitchUser = useSelector((state) => state.Auth.isSwitchUser);
	const isSwitchUserRef = useRef(isSwitchUser);

	useEffect(() => {
		isSwitchUserRef.current = isSwitchUser;
	}, [isSwitchUser]);

	const session_ = supabase.auth.session();
	function logoutUser() {
		setShowModal(true);
	}

	// useEffect(() => {
	// if (!mobileCheck()) {
	// 	document.documentElement.style.zoom = Number((1 / window.devicePixelRatio).toFixed(1));
	// }
	// if (document.body.clientWidth < /*screen width pixels*/) {
	// 	viewport = document.querySelector("meta[name=viewport]");
	// 	viewport.setAttribute('content', 'width=device-width, initial-scale=0.67, user-scalable=0');
	// }
	// }, []);
	// console.log("session===>", session_);
  useEffect(() => {
	if (!isAuthenticated) return;
  
	let cancelled = false;
	let subscription = null;
  
	(async () => {
	  // 1) get local refresh token
	  const localRT = getLocalRefreshToken();
	  if (!localRT) return;
  
	  // 2) v1 session getter
	  const session = supabase.auth.session();
	  const email = session?.user?.email;
	  if (!email) return;
  
	  // 3) fetch your LeadLogin row by email (which row to watch)
	  const { data: row, error } = await supabase
		.from("LeadLogin")
		.select("id, refresh_token_hash")
		.eq("email", email)
		.limit(1)
		.single();
  
	  if (cancelled || error || !row) return;
  
	  // 4) immediate check vs local hash
	  const localHash = await sha256Hex(localRT);
	  if (row.refresh_token_hash && row.refresh_token_hash !== localHash) {
		if (!showModal) logoutUser();   // guard to avoid duplicate popups
		return; // no need to subscribe if already invalid
	  }
  
	  // 5) v1 realtime subscription to THIS row
	  subscription = supabase
		.from(`LeadLogin:id=eq.${row.id}`)
		.on("UPDATE", async (payload) => {
		  const newHash = payload?.new?.refresh_token_hash;
		  if (!newHash) return;
  
		  const rt = getLocalRefreshToken();
		  if (!rt) return;
  
		  const currentLocalHash = await sha256Hex(rt);
		  if (newHash !== currentLocalHash) {
			if (!showModal) logoutUser(); // guard
		  }
		})
		.subscribe();
	})();
  
	// cleanup
	return () => {
	  cancelled = true;
	  if (subscription) {
		if (typeof supabase.removeSubscription === "function") {
		  supabase.removeSubscription(subscription);
		} else if (typeof subscription.unsubscribe === "function") {
		  subscription.unsubscribe();
		}
	  }
	};
  }, [isAuthenticated, showModal]);
  
	function getLocalRefreshToken() {
		try {
			const raw = localStorage.getItem("supabase.auth.token");
			if (!raw) return null;
			const json = JSON.parse(raw);
			return (
				json?.currentSession?.refresh_token ||
				json?.session?.refresh_token ||
				json?.refresh_token ||
				null
			);
		} catch { return null; }
	}
  


	useEffect(() => {
		isAuthenticatedUseRef.current = isAuthenticated;
	}, [isAuthenticated]);

	useEffect(() => {
		let flag = false;
		supabase.auth.onAuthStateChange((event, session) => {
			// if ((event === "TOKEN_REFRESHED" || event === "SIGNED_OUT") && !flag && !showModal && isAuthenticatedUseRef.current && !isSwitchUser) {
			if (
				(event === "TOKEN_REFRESHED" || event === "SIGNED_OUT") &&
				!flag &&
				!showModal &&
				isAuthenticatedUseRef.current &&
				isSwitchUserRef.current === false
			) {
				logoutUser();
				//todo Logout Logic
				flag = true;
			} else {
				flag = false;
				//   dispatch(actions.authSwitchUserFalse())
			}
		});
	}, []);

	const AppWrapper = () => {
		let routes = useRoutes([
			{
				path: "/",
				element: <Login />,
			},
			{
				path: "/Services",
				element: <Services />,
			},
			{
				path: "/Home",
				element: isAuthenticated ? <Mainpage /> : <Navigate to="/" />,
				children: [
					{ path: "", element: <Navigate to="/Home/Dashboard" /> },
					{ path: "Dashboard", element: <Home /> },
					{ path: "Tokens", element: <Tokens /> },
					{ path: "Allotments", element: <Home /> },
					{ path: "Profile", element: <Profile /> },
					{ path: "Documents", element: <Documents /> },
					{ path: "PreselectConfirmations", element: <PreselectAllotments /> },
					{ path: "CancelUnitsRequest", element: <CancelUnits /> },
					{ path: "Transaction", element: <Transactions /> },
					// { path: "EMandate", element: <EMandateAllotments /> },
					{ path: "EMandate", element: <EMandateAllotmentRoute /> },
					{ path: "LoanAssist", element: <LoanAssist /> },
					{ path: "Tutorials", element: <TutorialsPage /> },

					{
						path: "Services",
						element: <Services />,
					},
					{
						path: "PrivacyPolicy",
						element: <PrivacyPolicy />,
					},
					{
						path: "TermsAndConditions",
						element: <TermsAndConditions />,
					},
					{
						path: "CancellationPolicy",
						element: <CancellationPolicy />,
					},
					{
						path: "ContactUs",
						element: <ContactUs />,
					},
					{
						path: "AboutUs",
						element: <AboutUs />,
					},
					{
						path: "Help",
						element: <Help />,
					},
					{
						path: "BuildingSelection",
						element: <BuildingSelection />,
					},
					{
						path:"UnitFloorMap",
						element:<FloorMappingNew />
					},
					{ path: "UnitSelection", element: <OnlineBookingUnitSelection /> },
					{ path: "singleUnitSelectionDetails", element: <SingleUnitSelectionDetails /> },
					
					{ path: "TowerA1UnitSelection", element: <TowerA1UnitSelection /> },
					{ path: "TowerA2UnitSelection", element: <TowerA2UnitSelection /> },
					{ path: "TowerB1UnitSelection", element: <TowerB1UnitSelection /> },
					{ path: "TowerB2UnitSelection", element: <TowerB2UnitSelection /> },
					{ path: "EMandateSplit", element: <EMandateSplit /> }, 
					{ path: "SplitOption", element: <SplitOption /> }, 
					{ path: "BankVerification", element: <BankVerification /> }, 
					{ path: "ConfirmPaymentSchedule", element: <ConfirmPaymentSchedule /> },
					{path: "EMandateAllotmentHandlerPage", element: <EMandateAllotmentHandlerPage /> },
					{path: "SingleApplicant" , element : <SingleApplicant />},
					{path: "SplitAmount" , element : <SplitAmount/>},
					{path: "EMandateDashboard", element: <EMandateDashboard /> }
				],
			},
		]);

		return routes;
	};
	return (
		<>
			<div style={{ height: "100vh", overflow: "hidden" }}>
				{/* <Router> */}
				<AppWrapper />
				{/* </Router> */}
				<ToastContainer style={{ fontSize: "1.5rem" }} />
				<Loading />
			</div>
			{/* {showModal && (
			<ConfirmationAlert
			close={() => {
			  setShowModal(false);
			}}
			open={showModal}
			returnRespButton={'OK'}
			title={'Warning'}
			subTitle={
			  'Your session has expired. Please re-login'
			}
			confirm={(e) => {
			  logOut().then(({ err }) => {
				dispatch(actions.authLogout());
				setShowModal(false);
				navigate('/');
			  });
			}}
		  />
		  )} */}
			{showModal && (
				<>
					<LogoutPopup
						open={showModal}
						handleClose={() => {
							setShowModal(false);
						}}
					/>
				</>
			)}
		</>
	);
}

export default App;

// function that uses an insanely long and comprehensive regex which returns a true or false value depending on whether or not the user is browsing with a mobile.
function mobileCheck() {
	let check = false;
	(function (a) {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
				a
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
				a.substr(0, 4)
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}
